// "18 cards due" on the start page and in the Island. Counted when the browser is idle after the
// start page has painted, never on the way in. A change notice from another tab only ever makes it
// count again from what is stored (any page on this origin can post one).
import { readJSON, subscribe } from "../shared/store.js";
import { dueCount, nextDue } from "../shared/fc-due.js";
import { dateKey } from "../shared/activity.js";

const KEYS = ["revault:flashcards", "revault:fc-sched", "revault:fc-log"];
let n = 0;
export const dueN = () => n;

// The start page item: after open tasks, unless its ✕ was pressed today.
export function dueItem(count, home, now = Date.now()) {
	if (!(count > 0) || (home && home.dueX === dateKey(new Date(now)))) return null;
	return { kind: "due", n: count, ts: now };
}
export const dueLabel = (count) => (count > 200 ? "200+ cards due" : count === 1 ? "1 card due" : count + " cards due");

export function initDue(emit) {
	let timer = 0, queued = false;
	const idle = (fn) => (typeof requestIdleCallback === "function" ? requestIdleCallback(fn, { timeout: 4000 }) : setTimeout(fn, 300));
	const run = () => {
		queued = false;
		const sched = readJSON("revault:fc-sched", null), now = Date.now();
		const next = dueCount(readJSON("revault:flashcards", null), sched, readJSON("revault:fc-log", []), now);
		// Again when the next learning step comes due, and at least hourly (the study day turns at 4 am).
		const at = nextDue(sched, now);
		clearTimeout(timer);
		timer = setTimeout(soon, Math.min(3600e3, at ? at - now + 1000 : 3600e3));
		if (next === n && run.done) return;
		run.done = true;
		n = next;
		emit("due", { n });
		dispatchEvent(new CustomEvent("rv:due", { detail: { n } }));
	};
	const soon = () => { if (!queued) { queued = true; idle(run); } };
	KEYS.forEach((k) => subscribe(k, soon));
	document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") soon(); });
	requestAnimationFrame(() => setTimeout(soon, 0));
}
